<template>
    <v-dialog v-model="show" max-width="350" ref="MsgBox" id="msgBox">
        <v-card>
            <v-card-title class="headline">{{title}}</v-card-title>
            <v-card-text>{{message}}</v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-for="(action,index) in actions" :key="index"
                       :class="index === defaultAction ? 'defaultAction' : ''"
                       depressed
                       @click="actionHandler(action)">
                    {{action}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
   export default {
      name: "msgBox",

      data() {
         return {
            resolve: null,
            selectedAction: null,

            show: false,
            title: null,
            message: null,
            icon: null,
            actions: null,
            defaultAction: -1
         }
      },

      watch: {
         show(nVal) {
            if (!nVal) {
               this.resolve(this.actions.indexOf(this.selectedAction));
            }
         }
      },

      methods: {
         actionHandler(action) {
            this.selectedAction = action;
            this.show = false;
         },

         showMsgBox(msgObj) {
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.selectedAction = null;

               this.title = msgObj.title;
               this.message = msgObj.message;
               this.icon = msgObj.icon;
               this.actions = msgObj.actions;
               this.defaultAction = msgObj.defaultAction;

               this.show = true;
            });
         },

         confirm(msgObj) {
            return this.showMsgBox(msgObj);
         }
      }
   }
</script>

<style scoped>
   .defaultAction {
      background-color: var(--primary-color) !important;
      color: var(--card-color) !important;
   }
   .v-card__title {
      padding-bottom: 0;
   }

   .v-card__text {
      padding-top: 10px;
   }
</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/msgBox/msgBox.vue